import fetch from 'cross-fetch';
import { ApiV1Base, ApiPrefix, getCookie, json, statusCheck } from '../util/icwUtility';

export const actUploadFilesRecord = async (files, path) => {
  const formData = new FormData();
  const token = getCookie('token');
  const uploadPath = token ? '/files/upload' : '/files/upload/noLogin';

  if (Array.isArray(files)) {
    files.forEach((file) => {
      formData.append('file', file);
    });
    formData.append('path', path);
  }

  try {
    const fileArr = await fetch(`${ApiV1Base}${ApiPrefix}${uploadPath}`, {
      method: 'POST',
      headers: {
        Authorization: token,
        Accept: 'application/json',
      },
      body: formData,
    })
      .then(statusCheck)
      .then(json)
      .then((data) => data)
      .catch((err) => {
        throw err;
      });

    const docRecord = await fetch(`${ApiV1Base}${ApiPrefix}/files/create/document/record`, {
      method: 'POST',
      headers: {
        Authorization: token,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        files: fileArr,
        path,
      }),
    })
      .then(statusCheck)
      .then(json)
      .then((data) => data)
      .catch((err) => {
        throw err;
      });

    return docRecord;
  } catch (err) {
    return err;
  }
};

// GET SHARE FILES

export const getShareFiles = async (token) => {
  try {
    const filesArr = await fetch(`${ApiV1Base}${ApiPrefix}/product/shareFiles/${token}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then(statusCheck)
      .then(json)
      .then((data) => data)
      .catch((err) => {
        throw err;
      });

    if (filesArr.success) {
      return filesArr;
    }
  } catch (err) {
    return err;
  }
};

// GET DOWNLOAD FILES

export const getBulkDownloadFiles = async (docIds) => {
  try {
    const objFile = await fetch(`${ApiV1Base}${ApiPrefix}/product/download`, {
      method: 'POST',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        docIds,
      }),
    })
      .then(statusCheck)
      .then(json)
      .then((data) => data)
      .catch((err) => {
        throw err;
      });

    if (objFile.success) {
      return objFile;
    }
  } catch (err) {
    return err;
  }
};

// UPLOAD FILE

export const actFileUpload = (params, files, apiPath, onSuccess, onError) => {
  try {
    // form-data
    const formData = new FormData();
    Object.entries(params).forEach(([key, value]) => {
      formData.append(key, value);
    });
    for (let i = 0; i < files.length; i++) {
      formData.append('file', files[i], files[i].name);
    }

    fetch(`${ApiV1Base}${ApiPrefix}${apiPath}`, {
      method: 'POST',
      headers: {
        Authorization: getCookie('token'),
      },
      body: formData,
    })
      .then(statusCheck)
      // .then(json)
      .then(() => {
        if (onSuccess) onSuccess();
      })
      .catch((error) => {
        if (onError) onError(error);
        throw error;
      });
  } catch (error) {
    if (onError) onError(error);
    throw error;
  }
};
